import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, getToken } from '../../hooks/useAuth';
import { CIcon } from '@coreui/icons-react';
import { cilCursor, cilMap } from '@coreui/icons';
import {
  CCard,
  CCardBody,
  CCol,
  CRow,
  CButton,
  CSpinner
} from '@coreui/react';
import '../../index.css';

export default function DetailFound({ profile, setProfile }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { token } = useAuth();

  useEffect(() => {
    const tryRedirect = async () => {
      // 1. Obtener Token de manera robusta
      let localToken = null;
      try {
        const tokenRaw = localStorage.getItem('token');
        if (tokenRaw) {
          if (tokenRaw.startsWith('{') || tokenRaw.startsWith('[')) {
            const parsed = JSON.parse(tokenRaw);
            localToken = parsed.token || tokenRaw;
          } else {
            localToken = tokenRaw;
          }
        }
      } catch (e) {
        localToken = getToken() || token;
      }

      if (!localToken) {
        setIsLoading(false);
        return;
      }

      const normalize = (data) => {
        if (!data) return [];
        if (Array.isArray(data)) return data;
        if (data.data && Array.isArray(data.data)) return data.data;
        if (data.projects && Array.isArray(data.projects)) return data.projects;
        if (typeof data === 'object') {
          const keys = Object.keys(data).filter(k => !isNaN(k));
          if (keys.length > 0) return keys.map(k => data[k]);
        }
        return [];
      };

      const getLatestId = (projects) => {
        if (!projects || projects.length === 0) return null;
        const sorted = projects.sort((a, b) => parseInt(b.id, 10) - parseInt(a.id, 10));
        return sorted[0].id;
      };

      // 2. Prioridad 1: Memoria de sesión (Último visitado)
      const lastVisited = localStorage.getItem('lastProjectVisited');
      if (lastVisited) {
        navigate(`/detail-project/${lastVisited}`);
        return;
      }

      // 3. Prioridad 2: Cache de proyectos (Lo que el Dashboard ya bajó)
      const cachedData = localStorage.getItem('data');
      if (cachedData) {
        try {
          const projects = normalize(JSON.parse(cachedData));
          const latestId = getLatestId(projects);
          if (latestId) {
            navigate(`/detail-project/${latestId}`);
            return;
          }
        } catch (e) { }
      }

      // 4. Prioridad 3: Consultar API (Última instancia)
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/jwt/list/project`, {
          headers: { 'Authorization': 'Bearer ' + localToken }
        });

        if (response.ok) {
          const listData = await response.json();
          const latestId = getLatestId(normalize(listData));
          if (latestId) {
            navigate(`/detail-project/${latestId}`);
            return;
          }
        }
      } catch (error) {
        console.error("Error seeking latest project:", error);
      } finally {
        setIsLoading(false);
      }
    };

    tryRedirect();
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="text-center">
          <CSpinner color="primary" variant="grow" className="mb-3" />
          <p className="text-muted fw-bold">Cargando último proyecto...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light p-4">
      <CCard className="border-0 shadow-lg text-center p-5" style={{ maxWidth: '600px', borderRadius: '24px' }}>
        <CCardBody>
          <div className="mb-4 d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 rounded-circle p-4" style={{ width: '80px', height: '80px' }}>
            <CIcon icon={cilMap} size="3xl" className="text-primary" />
          </div>
          <h2 className="fw-bold text-dark mb-3">Tu Panel de Detalles</h2>
          <p className="text-muted mb-4 fs-5">
            Aún no has seleccionado un proyecto para ver sus detalles. Por favor, selecciona uno de tu lista principal.
          </p>
          <CButton
            onClick={() => navigate('/dashboard')}
            className="btn-primary-login px-5 py-3 shadow"
            style={{ borderRadius: '16px', fontWeight: 'bold' }}
          >
            <CIcon icon={cilCursor} className="me-2" />
            Explorar mis proyectos
          </CButton>
        </CCardBody>
      </CCard>
    </div>
  );
}


